import { PerformanceTargetStrategySupportedStrategiesEnum } from 'generated/resources/graphql'

export const targetHelper = (value?: PerformanceTargetStrategySupportedStrategiesEnum | null) => {
  return value === 'by_teams' || value === 'by_locations'
}
